import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MenuItemTranslatorService } from '@services/menu-item-translator.service';
import { MenuItem } from 'primeng/api';
import { Observable, of } from 'rxjs';
import { map, pluck, startWith } from 'rxjs/operators';

@Pipe({
  name: 'mit'
})
export class MITPipe implements PipeTransform {
  constructor(private mit: MenuItemTranslatorService, private translateService: TranslateService) {}

  transform(items: MenuItem[], scope: string): Observable<MenuItem[]> {
    if (!items || !scope) {
      return of([]);
    }

    return this.translateService.onLangChange.pipe(
      pluck('lang'),
      // We use startWith because onLangChange only fires on changes, not the initial "load"
      startWith(this.translateService.currentLang),
      map(() => this.mit.translateItems(scope, items))
    );
  }
}
